import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import styled from "styled-components";
// import { FormGroup as ReactFormGroup, Label as ReactLabel } from "@vzrf/react-forms";

import { setAuthAgentFormValues } from "./actions";

import { media } from "utils/style";
// import {Select as ReactSelect } from "common-components/FormContent";
import {DropdownSelect } from "@vds/selects";
import { Input } from "@vds/inputs";
import { Tooltip as ReactTooltip } from "common-components/Tooltip";
import { checkNestedObject } from "utils/checkNestedObject";
import Button from "common-components/Buttons";

class AssignAgentForm extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props, "authAgentInfo", "values")) {
      this.props.setAuthAgentFormValues();
    }
  }

  required = (value, ...label) => {
    if (value || typeof value === "number") {
      return undefined;
    }

    if (label && label[2]) {
      const el = document.querySelectorAll(`[for='${label[2]}']`);
      if (el && el[0]) {
        return `${el[0].textContent} is required.`;
      }
    }
    return "Required.";
  };

  emailsMatch = (val, allValues) => {
    if (allValues.entity_email && allValues.entity_email_confirm) {
      return allValues.entity_email === allValues.entity_email_confirm ? undefined : "Emails dont match";
    }
  };

  emailValid = val => {
    if (!/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val)) {
      return "Email invalid format";
    }
  };

  renderField = ({
    input,
    autoComplete,
    type,
    width,
    maxLength,
    content: { jsonKey: label, tooltip_information: tooltip },
    meta: { touched, error },
    ...extra
  }) => {
    const {
      state_selection: {
        genericList: [{ list: stateList }]
      }
    } = this.props;

    const commonProps = {
      id: input.name,
      error: touched && error,
      autoComplete: autoComplete ? autoComplete : "on",
      "aria-describedby": `${input.name}_error`,
      ...extra
    };

    return (
      <FormGroup width={width}>
        {/* <label htmlFor={input.name}>
          {label}
          {tooltip ? <Tooltip>{tooltip}</Tooltip> : null}
        </label> */}
        {type === "select" ? (
          <DropdownSelect
            {...input} 
            {...commonProps}
            required={true}
            readOnly={false}
            label={label}
            tooltip={tooltip ? {
              title: tooltip,
            } : null}
            >
            {stateList.map(state => (
              <option key={state.jsonKey} value={state.jsonValue}>
                {state.jsonValue}
              </option>
            ))}
          </DropdownSelect>
        ) : (
          <Input
            {...input}
            {...commonProps}
            required={ label === "Apt/suite/floor" ? false : true}
            readOnly={false}
            error={touched && error ? true : false}
            errorText={error}
            label={label}
            tooltip={tooltip ? {
              title: tooltip,
            } : null}
            onKeyPress={e => {
              this.props.invalid && e.key === "Enter" && e.preventDefault();
            }}
            maxLength={maxLength ? maxLength : "50"}
          />
        )}
        {/* {touched && error && (
          <ErrorMsg role="alert" id={`${input.name}_error`}>
            {error}
          </ErrorMsg>
        )} */}
      </FormGroup>
    );
  };

  handleCancelClick = () => {
    const { initial: initialValues } = this.props.authAgentInfo;

    Object.keys(initialValues).map(key => {
      return this.props.change(key, initialValues[key]);
    });
    this.props.onSubmit();
  };

  render() {
    const {
      formContent: { genericList, buttons }
    } = this.props;

    const topLabels = genericList[0].list;
    const bottomLabels = genericList[1].list;
    const phoneNumberLabels = genericList[2].list;

    return (
      <Form onSubmit={this.props.onSubmit}>
        <fieldset>
          <Legend>{genericList[0].text}</Legend>
          <Field
            component={this.renderField}
            validate={[this.required]}
            name="entity_name"
            content={topLabels[0]}
          />
          <Field
            component={this.renderField}
            validate={[this.required, this.emailValid]}
            name="entity_email"
            content={topLabels[1]}
          />
          <Field
            component={this.renderField}
            validate={[this.required, this.emailsMatch]}
            autoComplete="new-password"
            name="entity_email_confirm"
            content={topLabels[2]}
          />
        </fieldset>
        <fieldset>
          <Legend>{genericList[1].text}</Legend>
          <Div>
            <Field
              component={this.renderField}
              validate={[this.required]}
              name="street_address"
              content={bottomLabels[0]}
              width={49}
            />
            <Field
              component={this.renderField}
              name="secondary_address"
              content={bottomLabels[1]}
              width={49}
            />
            <Field
              component={this.renderField}
              validate={[this.required]}
              name="zip_code"
              content={bottomLabels[2]}
              normalize={val => val.replace(/[^\d-]/g, "")}
              maxLength="10"
              width={32}
            />
            <Field
              component={this.renderField}
              validate={[this.required]}
              name="city"
              content={bottomLabels[3]}
              width={32}
            />
            <Field
              component={this.renderField}
              validate={[this.required]}
              type="select"
              name="state"
              content={bottomLabels[4]}
              width={32}
            />
          </Div>
        </fieldset>
        <fieldset>
          <Legend>{genericList[2].text}</Legend>
          <Div>
            <Field
              component={this.renderField}
              validate={[this.required]}
              name="phone_number"
              content={phoneNumberLabels[0]}
            />
          </Div>
        </fieldset>
        {this.props.inEditMode ? (
          <div style={{ marginTop: "64px" }}>
            <Button type="submit" disabled={this.props.invalid}>
              Save changes
            </Button>
            <Button type="button" onClick={this.handleCancelClick} background="white_background">
              Cancel
            </Button>
          </div>
        ) : (
          <Button
            type="submit"
            style={{ marginTop: "64px" }}
            disabled={this.props.invalid}
            background={buttons[0].type}
          >
            {buttons[0].text}
          </Button>
        )}
      </Form>
    );
  }
}

const mapStateToProps = ({
  form: { authAgentInfo },
  pageContent: { assign_agent_form: formContent, state_selection },
  authAgentFormValues
}) => ({
  authAgentInfo,
  formContent,
  state_selection,
  initialValues: authAgentFormValues
});

AssignAgentForm = reduxForm({
  form: "authAgentInfo",
  destroyOnUnmount: false,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true
})(AssignAgentForm);

AssignAgentForm = connect(
  mapStateToProps,
  { setAuthAgentFormValues }
)(AssignAgentForm);

export default AssignAgentForm;

// const Tooltip = styled(ReactTooltip)`
//   display: inline-block;
//   margin-left: 8px;
//   vertical-align: middle;
// `;

const Form = styled.form`
  max-width: 385px;
  border-top: 4px solid #000;
  padding-top: 2px;
`;

const Div = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

// const Label = styled(ReactLabel)`
//   color: #747676;
//   font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
// `;

const FormGroup = styled.form`
  width: 100%;
  margin-bottom: 24px;
  ${({ width }) =>
    width &&
    `
    flex-basis: ${width}%;
  `}
`;

// const Input = styled(ReactInput)`
//   width: 100%;
//   max-width: 100%;
// `;

// const Select = styled(ReactSelect)`
//   width: 100% !important;
//   padding: 12px !important;
//   min-width: inherit !important;
//   height: inherit !important;
// `;

const Legend = styled.legend`
  font-size: 14px;
  line-height: 14.5px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  margin-bottom: 14px;
`;

// const ErrorMsg = styled.span`
//   display: block;
//   font-size: 10px;
//   line-height: 10px;
//   font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
//   max-width: 173px;
//   margin-top: 5px;

//   ${media.mobile`
//     max-width: 100%;  
//   `}
// `;
